/**
 * Shared banker axios instance — uses `banker_token` instead of staff `token`.
 */
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const bankerApi = axios.create({
  baseURL: `${API_BASE}/api`,
});

bankerApi.interceptors.request.use((config) => {
  const t = localStorage.getItem('banker_token');
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

bankerApi.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('banker_token');
      localStorage.removeItem('banker_profile');
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/banker/login')) {
        window.location.href = '/banker/login';
      }
    }
    return Promise.reject(err);
  }
);

export default bankerApi;
